import '../scss/main.scss';

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('needs-login');
    const submitBtn = document.getElementById('submitBtn');
    const loadingSpinner = document.getElementById('loadingSpinner');
    const buttonText = document.getElementById('buttonText');
    const resultMessage = document.getElementById('resultmessage');
    const messageG = document.getElementById('messageg');
    console.log(conf)
    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        // Reset validation
        clearValidation();
        
        const username = document.getElementById('username').value.trim();
        const password = document.getElementById('password').value.trim();
        
        // Validation
        let isValid = true;
        
        if (!username) {
            showFieldError('username', 'Veuillez saisir votre nom d\'utilisateur.');
            isValid = false;
        }
        
        if (!password) {
            showFieldError('password', 'Veuillez saisir votre mot de passe.');
            isValid = false;
        }
        
        if (!isValid) return;
        
        // Show loading
        showLoading(true);
        
        try {
            // Simuler une requête API
            const response = await fetch('/OAuth/login.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'keytime': conf.front.time,
                    'keypass': conf.front.pass                    
                },
                body: JSON.stringify({ username, password })
            });
            const data = await response.json();

            console.log(conf)
            console.log(data)
            // if (response.ok) {
            //     showMessage('Connexion réussie !', 'success');
            //     // Redirection après succès
            //     setTimeout(() => {
            //         // window.location.href = '/';
            //     }, 1000);
            // } else {
            //     showMessage(data.message || 'Identifiants incorrects', 'error');
            // }
        } catch (error) {
            showMessage('Erreur de connexion', 'error');
        } finally {
            showLoading(false);
        }
    });
    
    function showLoading(loading) {
        if (loading) {
            loadingSpinner.classList.add('show');
            buttonText.textContent = 'Connexion...';
            submitBtn.classList.add('btn-loading');
        } else {
            loadingSpinner.classList.remove('show');
            buttonText.textContent = 'Connexion';
            submitBtn.classList.remove('btn-loading');
        }
    }
    
    function showFieldError(fieldId, message) {
        const field = document.getElementById(fieldId);
        const feedback = document.getElementById(fieldId + 'Feedback');
        
        field.classList.add('is-invalid');
        feedback.textContent = message;
    }
    
    function clearValidation() {
        const fields = ['username', 'password'];
        fields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            field.classList.remove('is-invalid');
        });
        resultMessage.textContent = '';
        messageG.classList.remove('show');
    }
    
    function showMessage(message, type) {
        if (type === 'error') {
            resultMessage.textContent = message;
            messageG.textContent = message;
            messageG.classList.add('show');
        } else {
            resultMessage.className = 'small fw-bold mb-0 text-success text-center';
            resultMessage.textContent = message;
        }
    }
});